import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@app/services';
import { DirectivesModule, PipesModule, SharedModule } from '@app/shared';
import { Subscription } from 'rxjs';
import { AuthService } from '..';
import { AuthShellComponent } from '../shell';

@Component({
  imports: [SharedModule, DirectivesModule, PipesModule, AuthShellComponent],
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
})
export class ConfirmComponent extends BaseService implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);

  params$: Subscription;

  ngOnInit(): void {
    this.params$ = this.route.queryParams.subscribe(this.onParamsChange.bind(this));
  }

  ngOnDestroy(): void {
    this.params$.unsubscribe();
  }

  onParamsChange(params: { verify?: string }): void {
    const verify: string = params.verify ?? undefined;
    void this.confirm(verify);
  }

  async confirm(verify: string): Promise<void> {
    this._spin.start();
    await this.authService
      .confirm(verify)
      .then(() => {
        void this._alert.success('Usuário confirmado com sucesso!');
      })
      .catch(() => {
        void this._alert.error('Erro ao confirmar usuário!');
      })
      .finally(() => {
        this._spin.stop();
        void this.router.navigateByUrl('/');
      });
  }
}
